import React, { useEffect, useState } from 'react';
import Project from '../Project/Project';
import { projectDataStatic } from '../Projects/Projects';
import './HomeProjects.css';
import { db } from "../lib/init-firebase";
import loader from "../../images/Loading_icon.gif"
import { collection, getDocs } from "firebase/firestore";

const HomeProjects = () => {

    const [projects, setProjects] = useState([]);

    useEffect(() => {
        const projectsRef = collection(db, "projects");
        getDocs(projectsRef)
            .then((response) => {
                const newProjects = response.docs.map(doc => doc.data());
                newProjects.sort((a, b) => {
                    return a.serial - b.serial;
                });
                setProjects(newProjects);
            })
            .catch((error) => console.log(error.message));
    }, []);

    if (projects.length === 0) {
        return (
            <>
                <div style={{ height: "100vh", backgroundColor: "#1A3D5D" }} className="d-flex justify-content-center align-items-center">
                    <img src={loader} width="100px" alt="" />
                </div>
            </>
        )
    }

    return (
        <div className="container">
            <h1 className="heading text-center pb-3"><span style={{ borderBottom: '5px solid #0bc2c2' }} className="">Some of <span style={{ color: '#0bc2c2' }}>My Projects</span></span></h1>
            {
                projects.slice(0, 3).map(project => <Project key={project.id} project={project} />)
            }
            <div className="text-center">
                <a href="/portfolio"><button className="custom-btn mt-5">More Projects</button></a>
            </div>

        </div>
    );
};

export default HomeProjects;